import React from 'react';
import ReserveTdForm from '../components/ReserveTdForm';

const ReserveFromTd = () => (
  <>
    <ReserveTdForm />
  </>
);

export default ReserveFromTd;
